<template>
	<div class="padding-lg">
		<div class="padding-top-xl">
			<el-card class="box-card">
				<div slot="header" class="flex justify-between align-center">
					<div class="title">
						<span class="el-icon-search"></span>
						<span class="text-bold margin-left-sm">{{ $route.meta.title }}</span>
					</div>
					<div class="action"></div>
				</div>
				<div class="solid-bottom padding-bottom flex justify-between align-center">
					<div>
						<span class="el-icon-info"></span>
						钉钉中当前共有{{ tableData.length }}条信息。
						<el-button type="primary" size="small" round @click="getEmpFromDingTalk">
							<span class="el-icon-download"></span>
							重新获取数据
						</el-button>
					</div>
					<div>
						<el-button type="success" size="small" round @click="bindByMobileAuto">
							<span class="el-icon-connection"></span>
							按手机号自动绑定
						</el-button>
						<el-button type="warning" size="small" round @click="showDialogTbBindEmpInfo = true">
							<span class="iconfont-tongbu"></span>
							同步数据
						</el-button>
					</div>
				</div>
				<el-table :data="tableData" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column prop="avatar" align="center" label="头像">
						<template slot-scope="scope">
							<div class="avatar">
								<el-avatar :size="64" :src="scope.row.avatar" v-if="scope.row.avatar"></el-avatar>
								<el-avatar :size="64" icon="el-icon-user-solid" v-else></el-avatar>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" align="center" label="姓名"></el-table-column>
					<el-table-column prop="jobnumber" align="center" label="工号"></el-table-column>
					
					<el-table-column prop="jointime" align="center" label="入职时间">
					</el-table-column>
					<el-table-column prop="position" align="center" label="职位"></el-table-column>
					<el-table-column prop="mobile" align="center" label="手机"></el-table-column>
					<el-table-column align="center" label="绑定状态">
						<template slot-scope="scope">
							<span class="iconfont-bangding text-blue text-bold" v-if="scope.row.profile"></span>
							<span class="iconfont-bangding text-gray" v-else></span>
						</template>
					</el-table-column>
					<el-table-column align="left" label="绑定人员信息" width="230">
						<template slot-scope="scope">
							<div class="flex align-center" v-if="scope.row.profile">
								<div class="avatar">
									<el-avatar :size="64" :src="scope.row.profile.avatar" v-if="scope.row.profile.avatar"></el-avatar>
									<el-avatar :size="64" icon="el-icon-user-solid" v-else></el-avatar>
								</div>
								<div class="margin-left text-left">
									<div class="text-bold">
										<span class="text-blue" v-if="scope.row.profile.gender == 1">{{ scope.row.profile.name }}</span>
										<span class="text-pink" v-else-if="scope.row.profile.gender == 2">{{ scope.row.profile.name }}</span>
										<span class="text-black" v-else>{{ scope.row.profile.name }}</span>
										<el-tag size="mini" effect="plain" type="info" class="margin-left-xs">{{ scope.row.profile.officeid }}</el-tag>
										<el-tag size="mini" effect="light" type="danger" class="margin-left-xs" v-if="scope.row.profile.stateflag == 0">离职</el-tag>
									</div>
									<div class="text-purple">{{ scope.row.profile.position }}</div>
									<div class="text-grey text-left">{{ scope.row.profile.mobile }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<el-button size="small" round type="primary" @click="bindUser(scope.row)" v-if="!scope.row.profile">
								<span class="iconfont-bangding"></span>
								绑 定
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</div>
		<el-dialog title="同步数据" :visible.sync="showDialogTbBindEmpInfo" width="500px">
			<div class="padding-lr">
				<div class="flex text-orange padding solid radius">
					<span class="text-sl el-icon-info"></span>
					<span class="margin-left">
						同步数据只会同步已经和钉钉绑定的用户信息；如果单方不存在数据会使用存在数据一方的数据，在有相同数据存在时会依照你选择的主数据方进行同步。
					</span>
				</div>
			</div>
			<el-form label-suffix=":" label-width="0" class="padding">
				<div class="padding-tb text-lg text-black text-bold">请选择主数据源：</div>
				<el-form-item label="" class="padding-tb">
					<el-radio-group v-model="tbBindEmpInfoType">
						<el-radio border label="oa">OA系统为主</el-radio>
						<el-radio border label="dingTalk">钉钉为主</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-divider></el-divider>
				<el-form-item label="">
					<el-button type="warning" @click="tbBindEmpInfo">开始同步</el-button>
					<el-button @click="showDialogTbBindEmpInfo = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="绑定账号" :visible.sync="dialogShowUserBind" width="500px">
			<div class="padding-lr-xxxl margin-bottom-lg">
				<div class="flex align-center padding-lr padding-tb-sm solid round">
					<div class="avatar">
						<el-avatar :size="64" :src="userBind.avatar" v-if="userBind.avatar"></el-avatar>
						<el-avatar :size="64" icon="el-icon-user-solid" v-else></el-avatar>
					</div>
					<div class="margin-left text-left  flex flex-direction justify-between">
						<div class="text-bold">
							<span class="text-blue" v-if="userBind.gender == 1">{{ userBind.name }}</span>
							<span class="text-pink" v-else-if="userBind.gender == 2">{{ userBind.name }}</span>
							<span class="text-black" v-else>{{ userBind.name }}</span>
						</div>
						<div class="text-purple">{{ userBind.position }}</div>
						<div class="text-grey text-left">{{ userBind.mobile }}</div>
					</div>
				</div>
			</div>
			<el-form :model="formUserBind" ref="formUserBind" label-suffix=":" label-width="100px" v-loading="loadingUserBind">
				<el-form-item label="OA内人员">
					<el-cascader :options="dataEmployee" :show-all-levels="false" :props="{ value: 'id', emitPath: false }" filterable v-model="formUserBind.employee">
						<template slot-scope="{ node, data }">
							<span class="iconfont-yuangong" v-if="data.type == 'emp'"></span>
							<span class="iconfont-bumen" v-else></span>
							<span :class="data.stateflag == 0 ? 'text-grey' : ''">
								<span class="margin-left-xs">{{ data.name }}</span>
								<span class="" v-if="data.officeid">({{ data.officeid }})</span>
							</span>
							<el-tag size="mini" type="info" class="margin-left-xs" v-if="data.stateflag == 0">离职</el-tag>
						</template>
					</el-cascader>
				</el-form-item>
				<el-divider></el-divider>
				<el-form-item label="">
					<el-button type="warning" @click="formSubmitUserBind">确认修改</el-button>
					<el-button @click="dialogShowUserBind = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			tableData: [],
			dataEmployee: [],
			formUserBind: {},
			dialogShowUserBind: false,
			loadingUserBind: false,
			userBind: {},
			showDialogTbBindEmpInfo: false,
			tbBindEmpInfoType: 'oa'
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getEmpFromDingTalk();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getEmpFromDingTalk() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/dingTalk&a=getEmpFromDingTalk', {}).then(
				res => {
					this.loading = false;
					if (typeof res.data != 'object') {
						this.$alert(res.data ? res.data : '(无返回数据)', {
							title: '返回数据格式错误',
							type: 'error'
						});
					} else {
						if (res.data.result == 'ok') {
							this.tableData = res.data.data.infos;
						} else {
							this.$alert(res.data.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		bindByMobileAuto() {
			this.$confirm('确定要按手机号自动绑定人员？', '操作确认', {
				type: 'warning'
			})
				.then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=hr/dingTalk&a=bindByMobileAuto', {}).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$alert('可绑定：' + res.data.data.count[0] + '个，绑定成功：' + res.data.data.count[1] + '个！', {
										title: '操作成功',
										type: 'success',
										callback: () => {
											this.getEmpFromDingTalk();
										}
									});
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				})
				.catch(() => {});
		},
		tbBindEmpInfo() {
			this.$confirm('确定要开始同步数据吗？该操作不可逆！', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						const loading = this.$loading({
							lock: true,
							text: '处理中...',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						this.$http.post('/server/index.php?m=hr/dingTalk&a=tbBindEmpInfo', { data: { type: this.tbBindEmpInfoType } }).then(
							res => {
								loading.close();
								if (typeof res.data != 'object') {
									this.$alert(res.data ? res.data : '(无返回数据)', {
										title: '返回数据格式错误',
										type: 'error'
									});
								} else {
									if (res.data.result == 'ok') {
										this.$alert('钉钉更新成功了 ' + res.data.data.count[0] + ' 个用户信息，OA系统更新成功了' + res.data.data.count[1] + ' 个用户信息！', {
											title: '操作成功',
											type: 'success',
											callback: () => {
												this.getEmpFromDingTalk();
											}
										});
									} else {
										this.$alert(res.data.msg, {
											title: '操作错误',
											type: 'error'
										});
									}
								}
							},
							r => {
								loading.close();
								this.$alert('网络错误，指定的服务无法访问。', {
									title: '系统错误',
									type: 'error'
								});
							}
						);
					}
				}
			});
		},
		bindUser(user) {
			this.dialogShowUserBind = true;
			this.userBind = Object.assign({}, user);
			this.formUserBind = { userid: user.userid };
			if (this.dataEmployee.length < 1) {
				this.loadingUserBind = true;
				this.$http.post('/server/index.php?m=hr/dingTalk&a=getDataEmployee', {}).then(
					res => {
						this.loadingUserBind = false;
						if (typeof res.data != 'object') {
							this.$alert(res.data ? res.data : '(无返回数据)', {
								title: '返回数据格式错误',
								type: 'error'
							});
						} else {
							if (res.data.result == 'ok') {
								this.dataEmployee = res.data.data;
							} else {
								this.$alert(res.data.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						}
					},
					r => {
						this.loadingUserBind = false;
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				);
			}
		},
		formSubmitUserBind() {
			this.$refs['formUserBind'].validate(valid => {
				if (valid) {
					this.loadingUserBind = true;
					this.$http.post('/server/index.php?m=hr/dingTalk&a=bindUser', { data: this.formUserBind }).then(
						res => {
							this.loadingUserBind = false;
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$message('绑定成功！', {
										type: 'success'
									});
									this.dialogShowUserBind = false;
									this.getEmpFromDingTalk();
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							this.loadingUserBind = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style></style>
